import React, { Component } from 'react';
import { connect } from "react-redux";
import { debounce } from "lodash";
import axios from "axios";

import { setList, setOverlay } from '../../Actions/stakeholderActions';
import { EditAction, ActionRejectUser } from '../Common/Buttons/Icons';
import Icon from '../Common/DesignSystem/Icons/Icon';
import Button from '../Common/DesignSystem/Button';
import colours from '../Common/DesignSystem/Colours';

//A React component will allow us to quickly iterate and change our code. It provides 
class ReminderActionsComponent extends Component {
    constructor(props) {
        super(props);

        this.editReminder = this.editReminder.bind(this);
        this.onReminderCompleteHandler = debounce(this.onReminderCompleteHandler.bind(this), 500);
        this.onReminderReactivateHandler = debounce(this.onReminderReactivateHandler.bind(this), 500);
        this.onReminderDeleteHandler = debounce(this.onReminderDeleteHandler.bind(this), 500);
    }

    onReminderCompleteHandler(e, props) {
        e.stopPropagation();
        this.toggleDropdown();

        axios.post('/ajax/reminder/' + props.id + '/complete')
        .then((response) => {
            axios.get('/ajax/dashboard/overdueReminders')
            .then(function(response2) {
                props.dispatch(setList("SET_VEHICLE_REMINDER_LIST", response2.data.reminders.active))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";
    
                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });
    
                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
            if ("vehicle" in props.stakeholder.current_vehicle_details && props.V_ID === props.stakeholder.current_vehicle_details.vehicle.V_ID) {
                axios.get('/ajax/vehicle/' + props.V_ID)
                .then(function(response2) {
                    props.dispatch(setList("SET_VEHICLE_REMINDER_LIST", response2.data.reminders.active))
                    props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }
            showStatusMsg(response?.data.message, 'success');
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";
    
                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });
    
                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }
    onReminderReactivateHandler(e, props) {
        e.stopPropagation();
        this.toggleDropdown();

        axios.post('/ajax/reminder/' + props.id + '/reactivate')
        .then((response) => {
            axios.get('/ajax/dashboard/overdueReminders')
            .then(function(response2) {
                props.dispatch(setList("SET_VEHICLE_REMINDER_LIST", response2.data.reminders.active))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";
    
                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });
    
                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })

            if ("vehicle" in props.stakeholder.current_vehicle_details && props.V_ID === props.stakeholder.current_vehicle_details.vehicle.V_ID) {
                axios.get('/ajax/vehicle/' + props.V_ID)
                .then(function(response2) {
                    props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }
            showStatusMsg(response?.data.message, 'success');
            
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })

        //props.onApproveHandler(e, props);
    }

    onReminderDeleteHandler(e, props) {
        e.stopPropagation();
        this.toggleDropdown();

        if (confirm('Are you sure you want to delete this reminder? This action is permanent and cannot be undone.')) {
            axios.post('/ajax/reminder/' + props.id + '/delete')
            .then((response) => {
                axios.get('/ajax/dashboard/overdueReminders')
                .then(function(response2) {
                    props.dispatch(setList("SET_VEHICLE_REMINDER_LIST", response2.data.reminders.active))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
        
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
        
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
    
                if ("vehicle" in props.stakeholder.current_vehicle_details && props.V_ID === props.stakeholder.current_vehicle_details.vehicle.V_ID) {
                    axios.get('/ajax/vehicle/' + props.V_ID)
                    .then(function(response2) {
                        props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }
                showStatusMsg(response?.data.message, 'success');
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";
    
                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });
    
                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
            

        //props.onApproveHandler(e, props);
    }

    editReminder(event, props) {
        this.toggleDropdown();
        this.props.history.push(this.props.match.url + '/vehiclereminder/' + props.id + '/edit')
    }

    toggleDropdown() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');
    }

    render() {
        return (
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                {this.props.completed ? 
                    <Button label="Reactivate" secondary small onClick={(e) => {this.onReminderReactivateHandler(e, this.props)}} style={{marginRight: 8}}/>
                    : <Button label="Complete" secondary small onClick={(e) => {this.onReminderCompleteHandler(e, this.props)}} style={{marginRight: 8}}/>
                }
                <Icon name="Edit" onClick={(e) => this.editReminder(e, this.props)} style={{cursor: 'pointer', marginRight: 8, color: colours.primary.blue}}/>
                <Icon name="Trash" onClick={(e) => this.onReminderDeleteHandler(e, this.props)} style={{cursor: 'pointer', marginRight: 8, color: colours.accent.error_red}}/>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder
});

export default connect(mapStateToProps)(ReminderActionsComponent);